import { useTranslation } from "react-i18next";
import { trellisPalette } from "../../../custom/analytics/palettes";

import type React from "react";

interface WizardUpdateButtonProps {
  onClick: () => void;
  disabled?: boolean;
  text?: string;
  readyToProceed?: boolean;
}

export const WizardUpdateButton = ({ onClick, disabled, text, readyToProceed }: WizardUpdateButtonProps) => {
  const { t } = useTranslation(["common"]);
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={readyToProceed ? "proceedAnimation" : undefined}
      style={{
        transform: "none",
        boxShadow: "none",
        width: "100%",
        padding: "2rem",
        background: readyToProceed ? trellisPalette[0] : "#CCC",
        display: "flex",
        flexDirection: "column",
        border: "none",
        color: "#FFF",
        fontSize: "2rem",
        fontWeight: 600,
      }}
    >
      <small style={{ fontSize: "1.3rem", fontWeight: 500 }}>{t(($) => $.common.formWizard["Next Step"])}</small>
      <span>{text || t(($) => $.common.actions.Save)}</span>
    </button>
  );
};

interface WizardCancelButtonProps {
  onClick: () => void;
  text?: string;
  color?: string;
  children?: React.ReactNode;
  sectionEdit?: boolean;
}

export const WizardCancelButton = ({
  onClick,
  text,
  color,
  children,
  sectionEdit = false,
}: WizardCancelButtonProps) => {
  const { t } = useTranslation(["common"]);
  return (
    <button
      onClick={onClick}
      style={{
        transform: "none",
        boxShadow: "none",
        width: "100%",
        padding: "2rem",
        background: color ?? "#ABB5BE",
        display: "flex",
        flexDirection: "column",
        border: "none",
        color: "#FFF",
        fontSize: "2rem",
        fontWeight: 600,
      }}
    >
      {children}

      {text !== "Cancel" && !children && (
        <small style={{ fontSize: "1.3rem", fontWeight: 500 }}>{t(($) => $.common.formWizard["Previous Step"])}</small>
      )}
      <span>
        {text ?
          text
        : sectionEdit ?
          ""
        : t(($) => $.common.actions.Cancel)}
      </span>
    </button>
  );
};
